import type {Moment} from 'moment-timezone'
import type {ProductPathsT} from '@freckle/educator-entities/ts/common/helpers/products'
import {fancyClient} from '@freckle/educator-entities/ts/openapi-clients'

export type EditableGenericAssignmentAttributesT = {title: string; startsAt?: Moment}

export async function patchSubjectProductAssignment(
  productPaths: ProductPathsT,
  assignmentId: number,
  attributes: EditableGenericAssignmentAttributesT,
): Promise<void> {
  fancyClient.PATCH(
    '/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/assignments/{SubjectProductAssignmentP-Int64}',
    {
      params: {
        path: {
          'SubjectP-Subject': productPaths.subjectPath,
          'ProductP-AbbreviatedProduct': productPaths.productPath,
          'SubjectProductAssignmentP-Int64': assignmentId.toString(),
        },
      },
      body: attributes,
    },
  )
}

export async function deleteSubjectProductAssignment(
  productPaths: ProductPathsT,
  assignmentId: number,
): Promise<void> {
  fancyClient.DELETE(
    '/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/assignments/{SubjectProductAssignmentP-Int64}',
    {
      params: {
        path: {
          'SubjectP-Subject': productPaths.subjectPath,
          'ProductP-AbbreviatedProduct': productPaths.productPath,
          'SubjectProductAssignmentP-Int64': assignmentId.toString(),
        },
      },
    },
  )
}
